import baseBunny from "./base_rose/img_baseBunny_rose.jpg";
import baseBunnyP from "./base_rose/img_baseBunny_rose_p.jpg";

import base from "./base_rose/img_base_rose.jpg";
import baseP from "./base_rose/img_base_rose_p.jpg";

import baseBunnyCrochet from "./base_rose/img_baseBunnyCrochet_rose.jpg";
import baseBunnyCrochetP from "./base_rose/img_baseBunnyCrochet_rose_p.jpg";

import baseBunnyCrochetRattle from "./base_rose/img_baseBunnyCrochetRattle_rose.jpg";
import baseBunnyCrochetRattleP from "./base_rose/img_baseBunnyCrochetRattle_rose_p.jpg";

import baseBunnyRattle from "./base_rose/img_baseBunnyRattle_rose.jpg";
import baseBunnyRattleP from "./base_rose/img_baseBunnyRattle_rose_p.jpg";

import baseCrochet from "./base_rose/img_baseCrochet_rose.jpg";
import baseCrochetP from "./base_rose/img_baseCrochet_rose_p.jpg";

import baseCrochetRattle from "./base_rose/img_baseCrochetRattle_rose.jpg";
import baseCrochetRattleP from "./base_rose/img_baseCrochetRattle_rose_p.jpg";

import baseRattle from "./base_rose/img_baseRattle_rose.jpg";
import baseRattleP from "./base_rose/img_baseRattle_rose_p.jpg";

export default [
    {
        type: "base",
        noPostcard: base,
        withPostcard: baseP,
    },
    {
        type: "baseBunny",
        noPostcard: baseBunny,
        withPostcard: baseBunnyP,
    },
    {
        type: "baseBunnyCrochet",
        noPostcard: baseBunnyCrochet,
        withPostcard: baseBunnyCrochetP,
    },
    {
        type: "baseBunnyCrochetRattle",
        noPostcard: baseBunnyCrochetRattle,
        withPostcard: baseBunnyCrochetRattleP,
    },
    {
        type: "baseBunnyRattle",
        noPostcard: baseBunnyRattle,
        withPostcard: baseBunnyRattleP,
    },
    {
        type: "baseCrochet",
        noPostcard: baseCrochet,
        withPostcard: baseCrochetP,
    },
    {
        type: "baseCrochetRattle",
        noPostcard: baseCrochetRattle,
        withPostcard: baseCrochetRattleP,
    },
    {
        type: "baseRattle",
        noPostcard: baseRattle,
        withPostcard: baseRattleP,
    }
]